import React from 'react'
import styled, { css } from 'styled-components'

const width = '27'
const height = '27'
const viewBox = '0 0 27 27'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <g fill="none" fillRule="evenodd" transform="translate(1 1)" key="key-0">
      <path
        fill="#FFF"
        d="M16.896 18H7.852v-2.15h1.36v-2.874h-1.36v-1.853h1.36v-.544c0-3.153 2.04-4.692 4.488-4.692 1.3 0 2.473.408 3.298 1.25l-1.53 1.623c-.451-.45-1.054-.68-1.768-.68-1.241 0-2.202.765-2.202 2.601v.442h4.106v1.853h-4.106v2.873h5.398V18z"
      />
      <circle cx="12.5" cy="12.5" r="12.5" stroke="#FFF" strokeWidth="2" />
    </g>
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconPrice'
})
